module.exports = __webpack_public_path__ + "assets/media/year20.dcf57d05.mp4";